const AZURE_MAIL = {
  slug: "azure-mail",
  name: "Azure Mail",
  description: "Chainmail dyed with cobalt",
  rarity: "common",
  slot: "armor",
  shopCategory: "metal-armor",
  statChanges: [
    { stat: "armor", value: 8 },
    { stat: "blueColor", value: 3 }
  ],
  sprite: {
    sheet: "wardrobe/metal/metal_blue",
    frameIndex: 0
  },
  bodySprite: "characters/body/body_blue",
  tags: ["daily-rotation", "metal"]
};
export {
  AZURE_MAIL
};
//# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsiLi4vLi4vLi4vLi4vLi4vLi4vbGliL2l0ZW1zL2FybW9ycy9tZXRhbC9henVyZS1tYWlsLnRzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyJpbXBvcnQgeyBJdGVtRGVmaW5pdGlvbiB9IGZyb20gJy4uLy4uL3R5cGVzJztcblxuZXhwb3J0IGNvbnN0IEFaVVJFX01BSUw6IEl0ZW1EZWZpbml0aW9uID0ge1xuICBzbHVnOiAnYXp1cmUtbWFpbCcsXG4gIG5hbWU6ICdBenVyZSBNYWlsJyxcbiAgZGVzY3JpcHRpb246ICdDaGFpbm1haWwgZHllZCB3aXRoIGNvYmFsdCcsXG4gIHJhcml0eTogJ2NvbW1vbicsXG4gIHNsb3Q6ICdhcm1vcicsXG4gIHNob3BDYXRlZ29yeTogJ21ldGFsLWFybW9yJyxcbiAgc3RhdENoYW5nZXM6IFtcbiAgICB7IHN0YXQ6ICdhcm1vcicsIHZhbHVlOiA4IH0sXG4gICAgeyBzdGF0OiAnYmx1ZUNvbG9yJywgdmFsdWU6IDMgfSxcbiAgXSxcbiAgc3ByaXRlOiB7XG4gICAgc2hlZXQ6ICd3YXJkcm9iZS9tZXRhbC9tZXRhbF9ibHVlJyxcbiAgICBmcmFtZUluZGV4OiAwLFxuICB9LFxuICBib2R5U3ByaXRlOiAnY2hhcmFjdGVycy9ib2R5L2JvZHlfYmx1ZScsXG4gIHRhZ3M6IFsnZGFpbHktcm90YXRpb24nLCAnbWV0YWwnXSxcbn07XG4iXSwKICAibWFwcGluZ3MiOiAiQUFFTyxNQUFNLGFBQTZCO0FBQUEsRUFDeEMsTUFBTTtBQUFBLEVBQ04sTUFBTTtBQUFBLEVBQ04sYUFBYTtBQUFBLEVBQ2IsUUFBUTtBQUFBLEVBQ1IsTUFBTTtBQUFBLEVBQ04sY0FBYztBQUFBLEVBQ2QsYUFBYTtBQUFBLElBQ1gsRUFBRSxNQUFNLFNBQVMsT0FBTyxFQUFFO0FBQUEsSUFDMUIsRUFBRSxNQUFNLGFBQWEsT0FBTyxFQUFFO0FBQUEsRUFDaEM7QUFBQSxFQUNBLFFBQVE7QUFBQSxJQUNOLE9BQU87QUFBQSxJQUNQLFlBQVk7QUFBQSxFQUNkO0FBQUEsRUFDQSxZQUFZO0FBQUEsRUFDWixNQUFNLENBQUMsa0JBQWtCLE9BQU87QUFDbEM7IiwKICAibmFtZXMiOiBbXQp9Cg==
